import { render, staticRenderFns } from "./VoyageCargo.vue?vue&type=template&id=61bccb3e&scoped=true&"
import script from "./VoyageCargo.vue?vue&type=script&lang=js&"
export * from "./VoyageCargo.vue?vue&type=script&lang=js&"
import style0 from "./VoyageCargo.vue?vue&type=style&index=0&id=61bccb3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bccb3e",
  null
  
)

export default component.exports